<template>
    <label
        :for="id"
        :class="{
            checked: innerValue,
            disabled,
            labeled: !!label,
            [`size--${size}`]: size != null,
            multiline,
        }"
    >
        <input :id="id" type="checkbox" v-model="innerValue" />
        <span v-html="label" class="label--text"></span>
    </label>
</template>

<script>
export default {
    name: 'ModelCheckbox',
    props: {
        size: {
            type: String,
            default: null,
        },
        label: String,
        value: {
            default: null,
        },
        inputValue: [Boolean, Object, Array],
        disabled: {
            type: Boolean,
            default: false,
        },
        multiline: Boolean,
    },
    data() {
        return {
            id: null,
        };
    },
    model: {
        prop: 'input-value',
        event: 'change',
    },
    mounted() {
        this.id = 'input-' + this._uid;
    },
    computed: {
        isBoolean() {
            return this.value === true || this.value === false || this.value === null;
        },
        innerValue: {
            get() {
                if (Array.isArray(this.inputValue)) {
                    return this.inputValue.some((v) => v === this.value);
                } else {
                    return !!this.inputValue;
                }
            },
            set(v) {
                if (this.disabled) return;
                let newValue;
                if (Array.isArray(this.inputValue)) {
                    let index = this.inputValue.indexOf(this.value);
                    let newValue = this.inputValue.slice();
                    if (index > -1) {
                        newValue.splice(index, 1);
                    } else {
                        newValue.push(this.value);
                    }
                } else if (this.isBoolean) {
                    newValue = !this.inputValue;
                } else {
                    newValue = this.inputValue ? null : this.inputValue;
                }
                this.$emit('change', newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mt';

label {
    font-family: $font-montserrat;
    display: flex;
    font-weight: normal;
    font-size: rem(14);
    font-weight: 500;
    line-height: rem(20);
    margin-bottom: rem(20);
    user-select: none;
    align-items: center;

    @include on-mobile {
        font-size: mrem(14);
        line-height: mrem(20);
        margin-bottom: mrem(20);
    }

    color: #2a2626;

    input {
        display: none;
    }

    &.labeled {
        &::before {
            margin-right: rem(12);

            @include on-mobile {
                margin-right: mrem(12);
            }
        }

        @include on-mobile {
            &::before {
                margin-right: mrem(12);
            }
        }
    }

    &::before {
        flex: 0 0 auto;
        content: '';
        display: block;
        min-width: rem(18);
        min-height: rem(18);
        margin-right: rem(8);
        border: rem(2) solid #98a0a9;
        box-sizing: border-box;
        border-radius: rem(4);

        @include on-mobile {
            width: mrem(18);
            height: mrem(18);
            border: mrem(2) solid #98a0a9;
            border-radius: mrem(4);
            margin-right: mrem(8);
        }
    }

    &.size {
        &--small {
            font-size: rem(15);
            line-height: rem(22);

            @include on-mobile {
                font-size: mrem(15);
                line-height: mrem(22);
            }

            &::before {
                width: rem(16);
                height: rem(16);

                @include on-mobile {
                    width: mrem(16);
                    height: mrem(16);
                }
            }
        }

        &--large {
            font-size: rem(18);
            line-height: rem(26);

            @include on-mobile {
                font-size: mrem(18);
                line-height: mrem(26);
            }

            &::before {
                width: rem(20);
                height: rem(20);

                @include on-mobile {
                    width: mrem(20);
                    height: mrem(20);
                }
            }
        }
    }

    &:hover {
        cursor: pointer;

        &::before {
            border-color: #4663ab;
        }
    }

    &.checked::before {
        border-color: #4663ab;
        background-color: #4663ab;
        background-image: url('~@/assets/images/icons/checkbox.svg');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 60%;
    }

    &.disabled {
        opacity: 0.4;
        cursor: default;

        &:hover {
            &::before {
                opacity: 0.4;
                border-color: #2a2626;
            }
        }
    }

    &.multiline {
        align-items: flex-start;

        &::before {
            cursor: pointer;
            margin-top: rem(4);

            @include on-mobile {
                margin-right: mrem(4);
            }
        }

        &:hover {
            cursor: default;
        }
    }
}
</style>

<style lang="scss">
.label--text {
    a {
        color: #4663ab;
        cursor: pointer;
    }
}
</style>
